module.exports = __webpack_public_path__ + "static/media/01.49511f32.jpg";